export const borderRadius = "0.4em";
export const boxShadowColor = "rgba(0,0,0,0.1)";
export const lightColor = "rgb(255,255,255)";
export const secondaryColor = "rgb(57,181,74)";
export const primaryColor = "rgb(50,131,230)";
